/**
 * A wrapper around Leaflet popup.
 */
class LeafletPopup {
  constructor(content) {
    this.maps = null;
    this._marker = null;

    this.contentEl = document.createElement('div');
    this.contentEl.classList.add('map-popup-container');
    this.contentEl.innerHTML = content;
    this.native = window.L.popup({
      closeButton: false,
      maxWidth: 480,
    });
    this.native.setContent(this.contentEl);
  }

  get position() {
    return undefined;
  }
  set position(loc) {
    /* not implemented */
  }
  get marker() {
    return this._marker;
  }
  set marker(marker) {
    this._marker = marker;
    this._marker.native.bindPopup(this.native);
  }

  get attached() {
    return this.maps;
  }
  attachTo(maps) {
    this.maps = maps;
    this._marker.native.openPopup();

    let mapRect = window.map_bounds();
    let contentRect = this.contentEl.getBoundingClientRect();

    const margin = 25;
    let topDiff = contentRect.top - mapRect.top;
    let panY = (topDiff < 0 && topDiff - margin) || 0;
    let leftDiff = contentRect.left - mapRect.left;
    let rightDiff = contentRect.right - mapRect.right;
    let panX =
      (leftDiff < 0 && leftDiff - margin) ||
      (rightDiff > 0 && rightDiff + margin) ||
      0;
    if (panX != 0 || panY != 0) {
      this.maps.panBy(panX, panY);
    }
  }

  deattach() {
    this.maps = null;
    this._marker.native.closePopup();
  }
}

export { LeafletPopup };
